import SolicitudPagoCategoriaService from "@/api/services/finanzas/nomencladores/SolicitudPagoCategoriaService"
import Vue from "vue"

const state = () => ({
    solicitud_pago_categorias: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    SOLICITUD_PAGO_CATEGORIAS: state => {
        return state.solicitud_pago_categorias
    },
    SOLICITUD_PAGO_CATEGORIAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_SOLICITUD_PAGO_CATEGORIAS: (state, payload) => {
        state.solicitud_pago_categorias = payload
    },

    SET_SOLICITUD_PAGO_CATEGORIAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_SOLICITUD_PAGO_CATEGORIA: (state, payload) => {
        state.solicitud_pago_categorias.push(payload)
    },

    UPDATE_SOLICITUD_PAGO_CATEGORIA: (state, payload) => {
        state.solicitud_pago_categorias = state.solicitud_pago_categorias.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_SOLICITUD_PAGO_CATEGORIA: (state, payload) => {
        state.solicitud_pago_categorias = state.solicitud_pago_categorias.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_SOLICITUD_PAGO_CATEGORIAS: async ({ commit, state }, { filter, bancoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await SolicitudPagoCategoriaService.get({ filter, bancoEstado, ...pagination })
            if (status === 200) {
                commit("SET_SOLICITUD_PAGO_CATEGORIAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las categorías, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_SOLICITUD_PAGO_CATEGORIAS: async ({ commit }) => {
        try {
            let { data, status } = await SolicitudPagoCategoriaService.getAll()
            if (status === 200) {
                commit("SET_SOLICITUD_PAGO_CATEGORIAS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_SOLICITUD_PAGO_CATEGORIAS: async ({ commit }) => {
        try {
            let { data, status } = await SolicitudPagoCategoriaService.getAllRecords()
            if (status === 200) {
                commit("SET_SOLICITUD_PAGO_CATEGORIAS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar las categorías , inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_SOLICITUD_PAGO_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicitudPagoCategoriaService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_SOLICITUD_PAGO_CATEGORIA", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la categoría, inténtelo nuevamente"
            })
        }
    },

    ADD_SOLICITUD_PAGO_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicitudPagoCategoriaService.post(payload)
            if (status === 201) {
                commit("ADD_SOLICITUD_PAGO_CATEGORIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La categoría ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la categoría, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_SOLICITUD_PAGO_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await SolicitudPagoCategoriaService.put(payload)
            if (status === 200) {
                commit("UPDATE_SOLICITUD_PAGO_CATEGORIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La categoría ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la categoría, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_SOLICITUD_PAGO_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { status, data } = await SolicitudPagoCategoriaService.delete(payload)
            if (status === 204) {
                commit("DELETE_SOLICITUD_PAGO_CATEGORIA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La categoría ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_SOLICITUD_PAGO_CATEGORIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La categoría ha sido deshabilitada  satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la categoría, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
